var allCollections = [];
var selectedStyleCollection = null;
var selectedSize = null;
var selectedColor = null;
var selectedSizeProducts = {};
var selectedStep = 1;
var allSelectedProducts = [];
var colorsWiseProducts = {};
var selectedVariant = {};
var selectedProduct = null;
var isAnotherPair = false;
var customerData = null;
var isActiveSubscription = false;
var allSubscriptions = null;
var allStylesData = [];
var oldStylePrice = window.oldStylePrice ? window.oldStylePrice : '';
var oldPriceJson = []

class Funnel extends HTMLElement {
    constructor() {
        super();
        this.funnel = this;
        this._init();
    }

    async _init() {
        await this._renderCollectionSection();

        this.querySelector('[data-save-subscribe-loader]').classList.add('d-none');
        this.querySelector('[data-save-subscribe-content]').classList.remove('d-none');

        window.stylesData = document.querySelector('#global-metaobject-data')?.innerText;
        allStylesData = window.stylesData ? JSON.parse(window.stylesData) : {};

        //new development
        this._bindFunnelEvents();

        this.outStyleElments = this.querySelectorAll('[data-product_type]')
        this.outStyleElments.forEach(ele => ele.addEventListener('click', this._openFunnel.bind(this)));

        // Add to bag or Add to subscription box
        if (window.customerDetails?.email?.length > 0) {
            this._onLoad();
            if (window.customerDetails.customerTags.includes('REAL_ACTIVE_SUBSCRIBER')) {
                isActiveSubscription = true;
            }
        } else {
            // this.querySelector('[data-add_btn]').classList.remove('d-none');
            // this.querySelector('[data-subscription_btn]').classList.add('d-none');
        }

        this._loadMoreFAQ();

        document.querySelectorAll('[data-modal-opener="subscription-funnel-popup-v2"]').forEach(ele => {
            ele.addEventListener('click', (event) => {
                this._resetFunnel();
            })
        })
    }

    async _renderCollectionSection() {
        //to resolve issue of learn more button
        document.querySelector('[data-learn-more-faq]')?.addEventListener('click', (event) => {
            event.preventDefault();
            let targetEle = document.querySelector('#subscription-faq-1');
            if (targetEle) {
                window.scrollTo({
                    top: targetEle.offsetTop,
                    behavior: "smooth"
                });
            }
        })

        try {
            let url1 = '/collections/section-api-resource?section_id=subsciption-style-for-section';
            let url2 = '/collections/section-api-resource?section_id=subsciption-style-for-section-2';

            let [response1, response2] = await Promise.all([
                fetch(url1),
                fetch(url2)
            ]);

            if (response1.status === 500 || response2.status === 500) {
                throw new Error('One of the requests failed with status 500');
            }

            let data1 = await response1.text();
            let data2 = await response2.text();

            let tempDiv1 = document.createElement('div');
            tempDiv1.innerHTML = data1;

            let tempDiv2 = document.createElement('div');
            tempDiv2.innerHTML = data2;

            document.body.appendChild(tempDiv1);
            document.body.appendChild(tempDiv2);

            let tempAllCollectionsEle = document.querySelectorAll('[data-style-collection-json]');
            let tempCollections = [];
            tempAllCollectionsEle.forEach((scriptEle) => {
                tempCollections.push(JSON.parse(scriptEle.innerText));
            })
            tempCollections.forEach((collection) => {
                const collectionObj = { ...collection };
                let handle = collectionObj.collection.handle.replaceAll('highwaisted', 'high-waisted');
                let collectionProducts = Object.values(collectionObj['new-products']);
                let tempProducts = collectionProducts.map((product) => {
                    let tempProduct = product.product;
                    tempProduct['color_swatch'] = product.icon
                    return tempProduct;
                });
                collectionObj['products'] = tempProducts;
                delete collectionObj['new-products'];
                allCollections[handle] = collectionObj;
            });
        } catch (e) {
            console.log('Error from section rendering api => ' + e);
        }
    }

    _loadMoreFAQ() {
        const loadMoreFAQ = document.getElementById('load-more-faq');
        if (loadMoreFAQ) {
            loadMoreFAQ.addEventListener('click', function (event) {
                event.preventDefault();
                loadMoreFAQ.remove()
                document.querySelectorAll('.subscription-faq-1-wrapper .mobile-section .hide-faq').forEach((hideFaqElement) => {
                    hideFaqElement.classList.remove('hide-faq');
                })
                document.querySelectorAll('.subscription-faq-3-wrapper .hide-faq').forEach((hideFaqElement) => {
                    hideFaqElement.classList.remove('hide-faq');
                })
            })
        }
    }

    async _onLoad() {
        await rechargeSdk._authCustomer();
        await this._getRechargeCustomerDetails();
        if(customerData != false){
          await this._getSubscriptions();
        }
    }

    //new development
    _resetFunnel() {
        this.querySelector(`[data-funnel-tabs] [data-tab="underwear"]`)?.click();
    }

    _selectStyleValue(value) {
        let collectionHandle = value;
        if (collectionHandle) {
            collectionHandle = collectionHandle.replace("baller-high-waisted", "baller-highwaisted")
                .replace("biker-high-waisted", "biker-highwaisted");
        }
        this.querySelector('[data-style-select]').textContent = collectionHandle || 'Choose your style';
        this.querySelector('[data-style-select]').setAttribute('data-style-select', collectionHandle);
        this.querySelectorAll('[data-style-select-container] .custom-option').forEach(ele => ele.classList?.remove('selected'));

        return collectionHandle;
    }

    _selectSizeValue(value) {
        this.querySelector('[data-size-select]').textContent = value || 'Select a size';
        this.querySelector('[data-size-select]').setAttribute('data-size-select', value);
        this.querySelectorAll('[data-size-select-container] .custom-option').forEach(ele => ele.classList?.remove('selected'));
        if (value) {
            this.querySelectorAll(`[data-size-select-container] .custom-option[data-value="${value}"]`).forEach(ele => ele.classList?.remove('selected'));
        }
    }

    _formatCollectionHandle(handle) {
        let collectionHandle = handle?.toLowerCase().replaceAll(' ', '-');
        if (collectionHandle === "baller-highwaisted") {
            collectionHandle = collectionHandle.replace("baller-highwaisted", "baller-high-waisted");
        }
        if (collectionHandle === "biker-highwaisted") {
            collectionHandle = collectionHandle.replace("biker-highwaisted", "biker-high-waisted");
        }
        return collectionHandle.replace('icon 2.0', 'icon2').replace('boss 2.0', 'boss2');
    }

    _bindFunnelEvents() {
        this.querySelector('[data-funnel-v2-close]').addEventListener('click',
            () => this._resetFunnel());

        this.querySelectorAll('[data-funnel-tabs] [data-tab]').forEach(ele => {
            ele.addEventListener('click', event => {
                event.stopImmediatePropagation();
                let type = event.target.closest('[data-tab]')?.dataset.tab;
                this.querySelectorAll('[data-tab]').forEach(ele => ele.classList.remove('active'));
                event.target.closest('[data-tab]')?.classList?.add('active');

                //reset style and size
                this.querySelectorAll('[data-single_style]').forEach(ele => ele.classList.add('d-none'));
                this.querySelectorAll(`[data-single_style][data-style-type="${type}"]`).forEach(ele => ele.classList.remove('d-none'));
                let lastOption = document.querySelectorAll('.custom-option[data-style-type="underwear"]:not(.d-none)');
                if (lastOption.length > 0) {
                    let lastElement = lastOption[lastOption.length - 1];
                    lastElement.classList.add('last_padding_child');
                }
                this._selectSizeValue('');
                this._selectStyleValue('');
                this.querySelectorAll('[data-size-select-container] .custom-option').forEach(ele => ele.classList?.add('disabled'));
                this.querySelector('[data-account-size-step]')?.classList?.add('d-none');
                this.querySelector('#subscription-funnel-popup-v2 .view_size_guide')?.classList?.add('d-none');
                this.querySelectorAll('.custom-options,.custom-select-wrapper').forEach(ele => ele.classList.remove('open'));
                this.querySelector('[data-style-extra-info]').innerHTML = '';
                this.querySelector('[data-funnel-submit]')?.classList?.remove('loading');

                //items details and colors
                this.querySelector('[data-style-type-name]').innerHTML = type;
                let imgSrc = type === 'tops' ? 'https://cdn.shopify.com/s/files/1/1412/6778/files/Boss_d_svg.svg?v=1715677804'
                    : 'https://cdn.shopify.com/s/files/1/1412/6778/files/Baller_d_svg.svg?v=1715677804';
                this.querySelector('[data-style-preview]')?.setAttribute('src', imgSrc);
                let prices = this._getPriceInterval();
                this.querySelector('[data-price-interval]').innerHTML = `${this._formatMoney(prices[0])}-${this._formatMoney(prices[1])}`
                this.querySelectorAll('[data-limited-color-container],[data-core-color-container],[data-actual-style-price]').forEach(ele => ele.classList?.add('d-none'));

                //oos style
                this.querySelectorAll('[data-single_style]').forEach(item => {
                    let styleHandle = item.getAttribute('data-single_style');
                    if (!this._isAnySizeAvailableInCollection(styleHandle)) {
                        item.classList.add('disabled');
                    }
                })

                //submit button
                let submitButton = this.querySelector('[data-funnel-submit]');
                if (submitButton) {
                    submitButton.querySelector('[data-button-text]').innerHTML = 'Make selections';
                    submitButton.setAttribute('data-funnel-submit', 0)
                }

                selectedSize = selectedColor = selectedStyleCollection = selectedProduct = selectedVariant = null;
            })
        })

        this.querySelectorAll('[data-style-select-container] [data-single_style]').forEach(ele => {
            ele.addEventListener('click', event => {
                event.stopImmediatePropagation();
                event.stopPropagation();

                //manage collection style
                this.querySelectorAll('[data-single_style].selected').forEach(el => el.classList.remove('selected'));
                let collectionHandle = event.target.closest('[data-single_style]')?.getAttribute('data-single_style');
                collectionHandle = this._formatCollectionHandle(collectionHandle);
                selectedSize = selectedColor = selectedProduct = selectedVariant = null;
                selectedStyleCollection = allCollections[collectionHandle];
                event.target.closest('[data-single_style]').classList.add('selected');

                this.querySelector('[data-style-extra-info]').innerHTML = allStylesData[collectionHandle]?.description || '';

                let container = event.target.closest('[data-subscription-funnel-v2]');

                //empty size
                this._selectSizeValue('');

                //set details
                let price = ele.closest('[data-price-value]').getAttribute('data-price-value');
                let imgSrc = this._findDefaultImageByCollection(collectionHandle);
                this.querySelector('[data-price-interval]').innerHTML = this._formatMoney(price);
                let actualPrice = ele.closest('[data-price-value]').getAttribute('data-actual-price');
                let actualPriceEl = this.querySelector('[data-actual-style-price]');
                if (actualPriceEl && actualPrice) {
                    actualPriceEl.classList.remove('d-none');
                    actualPriceEl.innerHTML = this._formatMoney(actualPrice);
                }
                this.querySelector('[data-style-preview]')?.setAttribute('src', imgSrc);
                this.querySelector('#subscription-funnel-popup-v2 .view_size_guide')?.classList?.remove('d-none');

                let submitButton = container.querySelector('[data-funnel-submit]');
                if (submitButton) {
                    submitButton.querySelector('[data-button-text]').innerHTML = 'Make selections';
                    submitButton.setAttribute('data-funnel-submit', 0)
                }

                this._handleSizeSection(container);
                this._prepareColorHtml(container);

            })
        })

        this.querySelectorAll('[data-funnel-submit]').forEach(ele => {
            ele.addEventListener('click', (event) => {
                let status = ele.closest('[data-funnel-submit]')?.dataset?.funnelSubmit;
                if (status == 1) {
                    if (isActiveSubscription) {
                        this._createBulkSubscriptions(event);
                    } else {
                        this._addToBag(event);
                    }
                }
            })
        })

        this._resetFunnel();
    }

    _handleSizeSection(container) {
        this.querySelector('[data-account-size-step]')?.classList?.remove('d-none');
        if (selectedStyleCollection) {
            let option1ValuesArray = selectedStyleCollection.products.flatMap(entry => entry.variants.flatMap(variant => {
                if (variant?.available && variant?.inventory_quantity >= 5) return variant.option1?.toLowerCase()
            }));
            let uniqueOptionValuesArray = Array.from(new Set(option1ValuesArray));

            container.querySelector('[data-size-select-container]')?.querySelectorAll('[data-single_size]').forEach(ele => {
                let option = ele.getAttribute('data-single_size');
                let isSizeAvailable = selectedColor ? this._isSizeAvailableForColor(option) : true;
                if (uniqueOptionValuesArray.includes(option) && isSizeAvailable) {
                    ele.closest('[data-single_size]')?.classList.remove('disabled');
                } else {
                    ele.closest('[data-single_size]')?.classList.add('disabled');
                }
            });
            this._selectSizeValue(selectedSize ? selectedSize.toUpperCase() : '', container);
        } else {
            container.querySelectorAll('[data-size-select-container] .custom-option').forEach(ele => ele.classList?.add('disabled'));
        }
        container.querySelectorAll('.custom-options,.custom-select-wrapper').forEach(ele => ele.classList.remove('open'));

        this._bindSizeEvent(container);
    }

    _bindSizeEvent(container) {
        container.querySelectorAll('[data-size-select-container] [data-single_size]').forEach(ele => {
            ele.addEventListener('click', (event) => {
                event.stopPropagation();
                event.stopImmediatePropagation();

                selectedSize = event.target.closest('[data-single_size]').getAttribute('data-single_size');
                selectedVariant = selectedProduct ? this._findColorVariantBySize() : null;

                this._prepareColorHtml(container);

                let submitButton = container.querySelector('[data-funnel-submit]');
                if (selectedVariant) {
                    if (submitButton) {
                        submitButton.querySelector('[data-button-text]').innerHTML = isActiveSubscription ? 'ADD TO SUBSCRIPTION BOX' : 'ADD TO BAG';
                        submitButton.setAttribute('data-funnel-submit', 1)
                    }
                } else {
                    if (submitButton) {
                        submitButton.querySelector('[data-button-text]').innerHTML = 'Select a color';
                        submitButton.setAttribute('data-funnel-submit', 0)
                    }
                }
            })
        })
    }

    _prepareColorHtml(container) {
        if (window.globalVariables.woxer_only === 'true') {
            selectedStyleCollection.products = selectedStyleCollection.products?.filter((product) => {
                return product?.tags?.includes(window.globalVariables.woxer_only_product_tag) == false;
            });
        }

        let limitedColorsHtml = "";
        let coreColorsHtml = "";
        let allColorsInHtml = [];
        let selectedSwatchType = '';
        selectedStyleCollection.products?.forEach((product) => {
            let color = product.variants[0]?.option2?.toLowerCase();
            if (color && !product?.type?.includes('pack')) {
                let colorSrc = this._findColorSwatchByProduct(product);
                let isLimited = product.tags.includes('pp-limited_color') || false;
                let isColorAvailable = selectedSize ? this._isColorAvailableForSize(color) : true;
                let isColorAvailableForAnySize = this._isColorAvailableForAnySize(color);
                let repeatedColor = allColorsInHtml.includes(color);
                let colorHtml = `
                <a href="#" data-color-product-id="${product.id}" data-color="${color}" aria-label="${color}" ${color === selectedColor && isColorAvailable ? 'selected' : ''}
                class="d-block rounded-circle swatch-image position-relative ${color === 'pride pure' ? 'highlight-color' : ''} ${!isColorAvailable ? 'unavailable ' : ''}
                ${!isColorAvailableForAnySize || repeatedColor ? 'd-none' : ''} ${selectedProduct && selectedProduct.id == product.id ? 'selected' : ''}"
                 data-color-type="${isLimited ? 'limited' : 'core'}" title="${color}">
                    <img class="w-100 h-100 rounded-circle" src="${colorSrc}" role="presentation" alt="${color}">
                </a>
            `;
                allColorsInHtml.push(color);
                if (color === selectedColor) {
                    selectedSwatchType = color === selectedColor && isLimited ? 'limited' : 'core';
                }
                if (isLimited) {
                    limitedColorsHtml += colorHtml;
                } else {
                    coreColorsHtml += colorHtml;
                }
            }
        });

        container.querySelector(`[data-limited-container]`).innerHTML = limitedColorsHtml;
        container.querySelector(`[data-core-container]`).innerHTML = coreColorsHtml;

        container.querySelector('[data-limited-color-container]').classList.toggle('d-none', !limitedColorsHtml);
        container.querySelector('[data-core-color-container]').classList.toggle('d-none', !coreColorsHtml);

        if (selectedColor) {
            container.querySelectorAll('[data-color-print]').forEach(ele => ele.innerHTML = selectedColor);
            container.querySelector(`[data-color-print="${selectedSwatchType === 'limited' ? 'limited' : 'core'}"]`)?.classList?.remove('d-none');
        } else {
            container.querySelectorAll('[data-color-print]').forEach(ele => ele.classList.add('d-none'));
        }

        this._bindItemAddColorEvents(container);
    }

    _bindItemAddColorEvents(container) {
        container.querySelectorAll('[data-color-product-id]').forEach((ele) => {
            ele.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                ele.closest('[data-color-container]')?.querySelector('.selected')?.classList.remove('selected');
                ele.closest('[data-color-product-id]')?.classList.add('selected');
                selectedColor = ele.getAttribute('data-color')?.replace(/\u00A0/g, ' ');
                let productId = ele.getAttribute('data-color-product-id');
                selectedProduct = this._findProductByCollection(productId);
                selectedSize && (selectedVariant = this._findColorVariantBySize());
                this._handleSizeSection(container);
                let imgSrc = this._findImageByProduct(selectedProduct);
                this.querySelector('[data-style-preview]')?.setAttribute('src', imgSrc);

                let submitButton = container.querySelector('[data-funnel-submit]');
                if (selectedVariant) {
                    if (submitButton) {
                        submitButton.querySelector('[data-button-text]').innerHTML = isActiveSubscription ? 'ADD TO SUBSCRIPTION BOX' : 'ADD TO BAG';
                        submitButton.setAttribute('data-funnel-submit', 1)
                    }
                } else {
                    if (submitButton) {
                        submitButton.querySelector('[data-button-text]').innerHTML = 'Select a size';
                        submitButton.setAttribute('data-funnel-submit', 0)
                    }
                }

                let type = ele.getAttribute('data-color-type');
                let colorPrint = container.querySelector(`[data-color-print="${type === 'limited' ? 'limited' : 'core'}"]`);
                if (colorPrint) {
                    container.querySelectorAll(`[data-color-print]`).forEach(ele => ele.classList.add('d-none'));
                    colorPrint?.classList?.remove('d-none');
                    colorPrint.innerHTML = selectedColor;
                }
            })
        })
    }

    _findColorSwatchByProduct(product = selectedProduct) {
        let colorSwatch = product.color_swatch;
        if (colorSwatch == undefined) {
            colorSwatch = product.featured_image + '&width=200';
        }
        return colorSwatch;
    }

    _findColorVariantBySize(product = selectedProduct) {
        return product.variants.find((item) => item.option1.toLowerCase() == selectedSize.toLowerCase())
    }

    _findImageByProduct(product = selectedProduct) {
        return product ? product.images[product.images.length - 1] + '&width=300' : false;
    }

    _isColorAvailableForSize(color) {
        let available = false;
        selectedStyleCollection.products.forEach(product => {
            if (product.tags?.includes('SUBSCRIPTION_SHOW_ALWAYS')) {
                available = true;
            } else {
                product.variants?.forEach(variant => {
                    if (variant?.available && variant?.inventory_quantity >= 5 && variant.option2 && (variant.option2.toLowerCase().replace(/\u00A0/g, ' ') == color.toLowerCase()) && (variant.option1.toLowerCase() == selectedSize)) {
                        available = true;
                    }
                })
            }
        })

        return available;
    }

    _isColorAvailableForAnySize(color) {
        let available = false;
        selectedStyleCollection.products.forEach(product => {
            if (product.tags?.includes('SUBSCRIPTION_SHOW_ALWAYS')) {
                available = true;
            } else {
                product.variants?.forEach(variant => {
                    if (variant?.available && variant.option2 && variant?.inventory_quantity >= 5 && (variant.option2?.toLowerCase() == color.toLowerCase().replace(/\u00A0/g, ' '))) {
                        available = true;
                    }
                })
            }
        })

        return available;
    }

    _isSizeAvailableForColor(size, collection = selectedStyleCollection) {
        let available = false;
        collection.products.forEach(product => {
            if (product.tags?.includes('SUBSCRIPTION_SHOW_ALWAYS')) {
                available = true;
            } else {
                product.variants?.forEach(variant => {
                    if (variant?.available && variant?.inventory_quantity >= 5 && variant.option1 && (variant.option1.toLowerCase() == size.toLowerCase()) && (variant.option2.toLowerCase() == selectedColor)) {
                        available = true;
                    }
                })
            }
        })

        return available;
    }

    _findProductByCollection(id, collection = selectedStyleCollection) {
        return collection.products.find((item) => item.id == id)
    }

    _isAnySizeAvailableInCollection(handle) {
        let collectionHandle = this._formatCollectionHandle(handle);
        let collection = allCollections[collectionHandle];
        let available = false;
        collection?.products?.forEach(product => {
            if (product.tags?.includes('SUBSCRIPTION_SHOW_ALWAYS')) {
                available = true;
            } else {
                product.variants?.forEach(variant => {
                    if (variant?.available && variant?.inventory_quantity >= 5) available = true;
                })
            }
        })

        return available;
    }

    _getPriceInterval() {
        let divs = this.querySelectorAll('[data-price-value]:not(.d-none)');
        let prices = Array.from(divs).map(div => {
            let rate = parseFloat(div.getAttribute('data-price-value'));
            if (!isNaN(rate)) return rate;
        });
        prices = prices.filter(Boolean);
        const minPrice = Math.min(...prices);
        const maxPrice = Math.max(...prices);

        return [minPrice, maxPrice];
    };

    _formatMoney(price) {
        return Shopify.formatMoney(price, window.globalVariables.money_format);
    }

    _findDefaultImageByCollection(collection) {
        let collectionHandle = this._formatCollectionHandle(collection);
        switch (collectionHandle) {
            case 'baller' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Baller_d_svg.svg?v=1715677804'
            case 'ballerfly5' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Baller5-outline.png?v=1729084740'
            case 'ballerfly7' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Baller7-outline.png?v=1729084740'
            case 'baller-flex' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Baller_d_svg.svg?v=1715677804'
            case 'baller-high-waisted' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Baller_HW_d_svg.svg?v=1715677804'
            case 'baller-rib' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Baller_RIB_svg.svg?v=1715677805'
            case 'biker' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Biker_d_svg.svg?v=1715677804'
            case 'biker-flex' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Biker_d_svg.svg?v=1715677804'
            case 'biker-high-waisted' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Biker_HW_d_svg.svg?v=1715678140'
            case 'bikini' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Bikini_d_svg.svg?v=1715677805'
            case 'bikini-swim' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Bikini_d_svg.svg?v=1715677805'
            case 'bold' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Bold_d_svg.svg?v=1715677804'
            case 'boss' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Boss_d_svg.svg?v=1715677804'
            case 'boss-flex' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Boss_d_svg.svg?v=1715677804'
            case 'classic' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Classic_d_svg.svg?v=1715677804'
            case 'dreamer' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/dreamer_d_svg.svg?v=1715677805'
            case 'icon' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Icon_d_svg.svg?v=1715677804'
            case 'star' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Star_d_svg.svg?v=1715677804'
            case 'tank-top-rib' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Tank_top_d_svg.svg?v=1715673333'
            case 'icon2' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/icon2_d.svg?v=1715681798'
            case 'boss2' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/boss_2d.svg?v=1715681798'
            case 'boss-swim' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/boss_2d.svg?v=1715681798'
            case 'bralette-luxe' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/LuxeBra.png?v=1734011781'
            default:
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Baller_d_svg.svg?v=1715677804'
        }
    }

    _openFunnel(event) {
        let styleType = event.target.closest('[data-style_type]').getAttribute('data-style_type');
        let productType = event.target.closest('[data-product_type]').getAttribute('data-product_type')
        this.querySelector(`[data-funnel-tabs] [data-tab="${productType}"]`)?.click();
        setTimeout(() => {
            this.querySelector(`[data-style-select-container] [data-single_style="${styleType}"]`)?.click();
        }, 50)
    }

    _actionOnStep() {
        if (selectedStep == 1) {
            this.querySelector('[data-left-part]').classList.add('d-none');
            this.querySelector('[data-back-button]').classList.add('hide');
        } else {
            this.querySelector('[data-left-part]').classList.remove('d-none');
            this.querySelector('[data-back-button]').classList.remove('hide');
        }
    }

    _manageNavigationAndSteps() {
        this.querySelectorAll('[data-step].active').forEach((stepEle) => {
            stepEle.classList.remove('active');
        })
        this.querySelectorAll(`[data-step="${selectedStep}"]`).forEach((stepEle) => {
            stepEle.classList.add('active');
        })
        this.querySelectorAll('[data-right-step]').forEach((stepEle) => {
            stepEle.classList.add('d-none');
            if (parseInt(stepEle.getAttribute('data-right-step')) == selectedStep) {
                stepEle.classList.remove('d-none');
            }
        })

        this.querySelectorAll('[data-step-heading]').forEach((stepEle) => {
            stepEle.classList.add('d-none');
            if (parseInt(stepEle.getAttribute('data-step-heading')) == selectedStep) {
                stepEle.classList.remove('d-none');
            }
        })

        this._actionOnStep();
        this._allowManageSteps();
        this._manageLeftPart();
    }


    _allowManageSteps() {
        this.querySelectorAll('[data-step]').forEach((ele) => {
            let eleIndex = parseInt(ele.getAttribute('data-step'));
            if (eleIndex <= selectedStep || ele.classList.contains('done')) {
                ele.classList.remove('disabled');
            } else {
                ele.classList.add('disabled');
            }
        })
    }

    _markDoneStep() {
        this.querySelectorAll('[data-step]').forEach((stepEle) => {
            let stepIndex = parseInt(stepEle.getAttribute('data-step'))
            let previousIndex = selectedStep - 1;
            if (stepIndex <= previousIndex) {
                stepEle.classList.add('done');
            } else {
                stepEle.classList.remove('done');
            }
        })
    }

    /**
     * Get Colors from backend API
     */
    async _getAllColors() {
        if (allColors) return;

        let url = '/community/api/design-type-swatches';
        let response = await fetch(url,
            {
                method: 'GET',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                }
            })
        ;
        allColors = await response.json();
        Object.keys(allColors).forEach(key => {
            if (key.includes("baller-highwaisted")) {
                const newKey = key.replace("baller-highwaisted", "baller-high-waisted");
                allColors[newKey] = allColors[key];
                delete allColors[key];
            }
            if (key.includes("biker-highwaisted")) {
                const newKey = key.replace("biker-highwaisted", "biker-high-waisted");
                allColors[newKey] = allColors[key];
                delete allColors[key];
            }
        });
    }

    /**
     * Find product and variants
     */
    _findVariant() {
        let templColor = selectedColor.toLowerCase().replaceAll(' ', '-');
        selectedProduct = colorsWiseProducts[templColor];
        selectedVariant = selectedProduct.variants.filter(variant => {
            return variant.option1.toLowerCase() === selectedSize;
        })[0];
        this.querySelector('[data-variant-img] img').setAttribute('src', selectedProduct?.images[selectedProduct?.images.length - 1])
    }

    /**
     * Prepare Review section
     */
    _prepareForAddToCart() {
        if (!isAnotherPair) {
            allSelectedProducts.pop();
        }
        let obj = {
            product: selectedProduct,
            variant: selectedVariant
        }
        allSelectedProducts.push(obj);
        if (isAnotherPair) {
            isAnotherPair = false;
        }
        this._markDoneStep();
    }

    _closeFlow() {
        selectedStep = 1;
        this._manageNavigationAndSteps();
        isAnotherPair = true;
        allSelectedProducts = [];
        selectedStyleCollection = selectedSize = selectedSizeProducts = selectedColor = selectedProduct = selectedVariant = null;
    }

    // Manage Left Part 
    _manageLeftPart() {

        // Manage Style Image
        if (selectedStep <= 2) {
            if (selectedStyleCollection != null) {
                this.querySelector('[data-variant-img] img').setAttribute('src', selectedStyleCollection.collection_img)
            } else {
                this.querySelector('[data-variant-img] img').setAttribute('src', allCollections.baller.collection_img)
            }
        }
        if (selectedStep == 3) {
            if (selectedProduct != null && selectedProduct != {}) {
                this.querySelector('[data-variant-img] img').setAttribute('src', selectedProduct?.images[selectedProduct?.images.length - 1])
            } else {
                this.querySelector('[data-variant-img] img').setAttribute('src', selectedStyleCollection.collection_img)
            }
        }
        if (selectedStep == 4) {
            if (selectedProduct != null && selectedProduct != {}) {
                this.querySelector('[data-variant-img] img').setAttribute('src', selectedProduct?.images[selectedProduct?.images.length - 1])
            }
        }

        if (selectedStep > 1) {
            this.querySelector('[data-selected-style-details]').classList.remove('d-none');

            this.querySelector('[data-selected_style_name]').innerHTML = selectedStyleCollection.collection.title

            this.querySelector('[data-selected_style_name]').innerHTML = selectedStyleCollection.collection.title
            this.querySelector('[data-selected_style_info]').innerHTML = selectedStyleCollection.metafields.replaceAll('&quot;', '"');

            if (selectedSize != null) {
                this.querySelector('[data-selected_size]').innerHTML = selectedSize;
                this.querySelector('[data-selected_size]').closest('div').classList.remove('d-none');
            } else {
                this.querySelector('[data-selected_size]').closest('div').classList.add('d-none');
            }

        } else {
            this.querySelector('[data-selected-style-details]').classList.add('d-none')
        }
    }

    // Add to Bag
    async _addToBag(event) {
        try {
            event.target.closest('[data-funnel-submit]')?.classList?.add('loading');
            let finalItems = [];
            let revenue = 0;
            let items=[];
            let obj = {
                quantity: 1,
                id: selectedVariant.id,
                selling_plan: parseInt(selectedVariant.selling_plan_allocations[0].selling_plan_id),
                properties: {
                    _main_subscription: true,
                    _woxer_number: new Date(),
                    _first_order: true
                }
            }

            if (window.customerDetails?.customerTags.includes('Active Subscriber') || window.customerDetails?.customerTags.includes('REAL_ACTIVE_SUBSCRIBER')) {
                obj.properties['_active_subscriber'] = true;
            }
            finalItems.push(obj);

            revenue += parseInt(selectedVariant.selling_plan_allocations[0].price) / 100;

            try{
                let trackingObj={};
                let price = parseInt(selectedVariant.selling_plan_allocations[0].price) / 100;
                trackingObj['productId']=selectedProduct?.id;
                trackingObj['productVariantId']=selectedVariant.id;
                trackingObj['product_name']=selectedProduct?.title;
                trackingObj['product_image']=selectedProduct?.featured_image;
                trackingObj['price']=[{
                    "value": price,
                    "currency": "USD"
                }]
                items.push(trackingObj);
            }catch(err){
                console.log(err,'error in attentive')
            }

            let formData = {
                'items': finalItems
            };
            let response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            let data = await response.json();

            if (response.ok) {

            if (Zowie) {
                console.log('Zowie event fired ------------')
                Zowie.updateCart()
            }

                try {
                    window.VWO = window.VWO || [];
                    VWO.event = VWO.event || function () {VWO.push(["event"].concat([].slice.call(arguments)))};

                    if (window.location.href.includes('collections/subscribe')) {
                        VWO.event("subscriptionPurchase", {
                            revenue: revenue
                        });

                        setTimeout(() => {
                            VWO.event("customAddSubscriptionToCart", {
                                cart: 1
                            });
                            event.target.closest('[data-funnel-submit]')?.classList.remove('loading');
                        }, 300);
                    }

                    VWO.event("customAddToCart", {
                        cart: 1
                    });
                    Utility._triggerAddToCartView(items);
                } catch (e) {
                    console.error(e);
                }
            } else {
                console.error('Error:', response);
            }
            document.querySelector('[data-funnel-v2-close]').click();
        } catch (e) {
            event.target.closest('[data-funnel-submit]')?.classList?.remove('loading');
            console.log(e)
        }
    }

    async _getRechargeCustomerDetails() {
        customerData = await rechargeSdk._getCustomerDetails();
        window.activeSubscriptionCount = customerData.subscriptions_active_count || 0;
    }

    async _getSubscriptions() {
        allSubscriptions = await rechargeSdk._getSubscriptions();
        if (allSubscriptions && allSubscriptions.length) {
            window.activeSubscriptionCount = allSubscriptions.length;

            this.querySelector('[data-add_btn]')?.classList?.add('d-none');
            this.querySelector('[data-subscription_btn]')?.classList?.remove('d-none');
        } else {
            this.querySelector('[data-add_btn]')?.classList?.remove('d-none');
            this.querySelector('[data-subscription_btn]')?.classList?.add('d-none');
        }
    }

    async _createBulkSubscriptions(event) {
        try {
            event.target.closest('[data-funnel-submit]')?.classList?.add('loading');
            let price = selectedVariant.selling_plan_allocations[0].price / 100.00 || selectedVariant.price / 100.00;

            let config = {
                charge_interval_frequency: "1",
                address_id: allSubscriptions[0].address_id.toString(),
                order_interval_frequency: "1",
                order_interval_unit: "month",
                price: price.toString(),
                quantity: "1",
                properties: [
                    {
                        "name": "product_add_by",
                        "value": "admin"
                    },
                    {
                        "name": "isSwapping",
                        "value": "true"
                    },
                    {
                        "name": "_first_order",
                        "value": 'true'
                    }
                ],
                presentment_currency: window.customerDetails.rechargeCustomerDetails?.include?.addresses[0]?.presentment_currency,
                next_charge_scheduled_at: allSubscriptions[0].next_charge_scheduled_at,
                external_variant_id: {
                    ecommerce: selectedVariant.id.toString()
                }
            }

            let response = await rechargeSdk._createSubscriptionProduct(config);

            if (response) {
                window.location.href = "/account"
            }
        } catch (e) {
            event.target.closest('[data-funnel-submit]')?.classList?.remove('loading');
            console.log(e)
        }
    }
}

customElements.define("subscription-funnel", Funnel);
